import React, {useState, useEffect, useCallback} from "react";
import {BottomScrollListener} from "react-bottom-scroll-listener";
import I18n from 'i18n.js.erb'
import PrepaidCardsGrid from "./PrepaidCardsGrid";
import {
  CURRENCY_EURO,
  DEFAULT_PER_PAGE_PARAM,
  MEDIUM_DEBOUNCE_TIME,
  parseAmount,
  pluralize
} from "../../utils/utils";
import ErrorModal from "./ErrorModal";
import PrepaidCardsList from "./PrepaidCardsList";
import {debounce} from "lodash";




const IndexPrepaidCards = ({
  initial_prepaid_cards,
  sorting_options,
  amounts,
  userId,
  isSuperMiddleman
}) => {

  const initialPrepaidCards = JSON.parse(initial_prepaid_cards);
  const [initCompleted, setInitCompleted] = useState(false)
  const [prepaidCards, setPrepaidCards] = useState([]);
  const [prepaidCardsCount, setPrepaidCardsCount] = useState(0);
  const [globalMiddlemanFee, setGlobalMiddlemanFee] = useState(0);
  const initialFilters = {
    code: null, amount: null, sort_by: null, sorting_direction: 'desc'
  }
  const [filters, setFilters] = useState(initialFilters)
  const [filtersEnabled, setFiltersEnabled] = useState(window.innerWidth > 768);
  const [page, setPage] = useState(1);
  const [hasLoadedAllPrepaidCards, setHasLoadedAllPrepaidCards] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false)
  const [prepaidCardsAnimationDivider, setPrepaidCardsAnimationDivider ] = useState(Number.MAX_SAFE_INTEGER);
  const [viewMode, setViewMode] = useState('list')
  const [changeViewMode, setChangeViewMode] = useState(false);


  useEffect(() => {
    if (initCompleted && prepaidCards.length === 0) {
      getPrepaidCards()
    }
  }, [prepaidCards]);

  useEffect(() => {
    if (!initCompleted) {
      setInitCompleted(true)
      appendPrepaidCards(initialPrepaidCards.prepaid_cards)
      setPrepaidCardsCount(initialPrepaidCards.prepaid_cards_count)
      setGlobalMiddlemanFee(initialPrepaidCards.global_middleman_fee)
    }
  }, []);

  useEffect(() => {
    if (initCompleted) {
      debouncedUpdateFilters();
      return debouncedUpdateFilters.cancel;
    }
  }, [filters.code, debouncedUpdateFilters]);

  useEffect(() => {
    if (viewMode)
      setChangeViewMode(true);
  }, [ viewMode ]);


  useEffect(() => {
    if (changeViewMode)
      setChangeViewMode(false);
  }, [ changeViewMode ]);


  // Funzione che permette di ottenere dal server nuove carte prepagate da renderizzare sull'interfaccia grafica
  const getPrepaidCards = () => {
    let url = `/users/${userId}/prepaid_cards.json?page=${page}&per_page=${DEFAULT_PER_PAGE_PARAM}`
    Object.entries(filters).forEach(([fieldName, fieldValue]) => {
      if (fieldValue !== null)
        url += `&${fieldName}=${fieldValue}`
      else {
        if (fieldName === 'sort_by')
          url += `&${fieldName}=activated_at`
        if (fieldName === 'sorting_direction')
          url += `&${fieldName}=desc`
      }
    })

    if (!hasLoadedAllPrepaidCards) {
      setPrepaidCardsAnimationDivider(DEFAULT_PER_PAGE_PARAM);
      fetch(url, {
        method: 'GET'
      })
        .then(response => response.json())
        .then((data) => {
          setLoading(false);
          appendPrepaidCards(data.prepaid_cards);
          setPrepaidCardsCount(data.prepaid_cards_count)
          setGlobalMiddlemanFee(data.global_middleman_fee)
        })
        .catch((error) => {
          console.error("ERROR:", error);
          setShowErrorModal(true);
        });
    }
  }


  // Funzione che permette di concatenare nuove carte prepagate ottenute del server all'array che contiene tutti le
  // carte prepagate da mostrare sull'interfaccia grafica all'utente
  const appendPrepaidCards = (newPrepaidCards) => {
    setPrepaidCards(prepaidCards.concat(newPrepaidCards));
    setPage(page + 1);
    if (newPrepaidCards.length < DEFAULT_PER_PAGE_PARAM)
      setHasLoadedAllPrepaidCards(true)
  }


  // Funzione che permette di ottenere dal server le carte prepagate dell'utente che matchano con i filtri
  // di ricerca da lui specificati sull'interfaccia grafica
  const getPrepaidCardsByMatchingFilters = (filter, value) => {
    const newFilters = {...filters}
    newFilters[filter] = value;
    updateFilters(newFilters)
  }


  // Funzione che aggiorna i filtri di ricerca delle carte prepagate specificati dall'utente sull'interfaccia grafica
  // e rilancia la ricerca sulle carte che matchano con i nuovi filtri specificati
  const updateFilters = (newFilters) => {
    setFilters(newFilters);
    setLoading(true);
    setPage(1);
    setHasLoadedAllPrepaidCards(false);
    setPrepaidCards([]);
  }


  //Funzione che esegue l'update debouncato del filtro di ricerca delle carte prepagate per codice
  const debouncedUpdateFilters = useCallback(
    debounce(() => updateFilters(filters), MEDIUM_DEBOUNCE_TIME),
    [filters.code]
  );


  //Funzione che setta il nuovo filtro di ricerca delle carte prepagate per codice
  function onChangeDebouncedFilterHandler(key, value) {
    const newFilters = {...filters}
    newFilters[key] = value;
    setFilters(newFilters)
  }



  
  

  return (
    <React.Fragment>
      <div>
        <div>
          {/*  HEADER DELLA PAGINA */}
          <div className="row d-block justify-content-center text-center bg-aig-gradient w-100 m-0 color-white py-4 border-bottom-radius-20px px-3 mb-5">
            <div>
              <h2><b>{I18n.t("js.indexPrepaidCards.myPrepaidCards")}</b></h2>
            </div>
          </div>




          <div id="submission_lists_header_container">
            {/*  SEZIONE DEDICATA AI FILTRI DELLA PAGINA */}
            <div className="row mx-0 br-8px border-aiG-light-gray-imp bg-aiG-gray3-imp">
              <div className="col-12">
                <div className="row d-flex justify-content-between px-3 py-2">
                  <div className="w-50">
                    <div className="d-flex align-items-center justify-content-start text-left cursor-pointer"
                         onClick={(e) => setFiltersEnabled(!filtersEnabled)}>
                      <b>{I18n.t('js.filters.filters')}</b>
                      <img src={`/images/icons/black/arrow-${filtersEnabled ? 'up' : 'down'}.svg`} className="cursor-pointer ml-2"
                           alt="" width="10" height="10"
                      />
                    </div>
                  </div>

                  <div className="w-50">
                    <div className="d-flex align-items-center justify-content-end blue-label text-right cursor-pointer"
                         onClick={(e) => updateFilters(initialFilters)}>
                      <img src="/images/icons/blue/refresh.svg" className="mr-2" id="reset"
                           alt="" width="15" height="15"
                      />
                      {I18n.t('js.filters.cancelFilters')}
                    </div>
                  </div>
                </div>


                <div className={`row slide-animation-container slide-${filtersEnabled ? 'down' : 'up'}`}>
                  <hr className="separator my-0 w-100" />

                  <div className="col-12 pr-0">
                    <div className="row w-100 py-2">
                      <div className="col-6 col-md-4 col-lg-3 mb-2 py-1">
                        <p className="mb-0 filter-label">{I18n.t('js.filters.placeholderPrepaidCardCode')}</p>
                        <input
                          type="text"
                          value={filters.code ? filters.code : ""}
                          className={`form-control filter-input ${filters.code ? 'selected-label' : 'border-none'}`}
                          onChange={(e) => onChangeDebouncedFilterHandler('code', e.target.value)}
                          name="code_filter"
                          id="code_filter"
                        />
                      </div>

                      <div className="col-6 col-md-4 col-lg-3 mb-2 py-1">
                        <p className="mb-0 filter-label">{I18n.t('js.filters.amount')}</p>
                        <select
                          className={`form-control filter-input ${filters.amount ? 'selected-label' : 'border-none'} pl-2`}
                          value={filters.amount ? filters.amount : ""}
                          name="amount_filter"
                          id="amount_filter"
                          onChange={(e) => getPrepaidCardsByMatchingFilters('amount', e.target.value)}
                        >
                          <option value={""}></option>
                          {amounts.map(amount => {
                            return <option value={amount[0]} key={amount[0]}>
                              { parseAmount(amount[0], 0, true) }{CURRENCY_EURO}
                            </option>
                          })}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>




            {/*  SEZIONE DEDICATA ALLA GESTIONE DEI RISULTATI RENDERIZZATI SULLA PAGINA */}
            <div className="mb-3 mt-4 d-block d-sm-flex justify-content-start justify-content-sm-between align-items-center border-bottom-2px-lightgray3">
              <div className="d-flex justify-content-between align-items-center pb-3 px-0">
                <div className="align-items-center">
                  <b>{prepaidCardsCount}</b>&nbsp;
                  {pluralize(prepaidCardsCount, 'indexPrepaidCards.prepaidCard').toLowerCase()},&nbsp;
                  <b>{globalMiddlemanFee}{CURRENCY_EURO}</b>&nbsp;
                  {I18n.t("js.indexPrepaidCards.globalMiddlemanFee")}
                </div>
              </div>

              {
                initCompleted && prepaidCardsCount > 0 &&
                  <div className="d-flex justify-content-start justify-content-sm-end pb-3 px-0">
                    <select
                      className={`form-control minW-125px gray-label d-flex ${viewMode ? 'selected-label' : ''} mx-3`}
                      name="view_as"
                      id="view_as"
                      value={viewMode ? viewMode : ''}
                      onChange={(e) => {
                        setViewMode(e.target.value);
                        setPrepaidCardsAnimationDivider(Number.MAX_SAFE_INTEGER);
                      }}>
                      <option value="" disabled hidden>{I18n.t('js.filters.viewMode.viewAs')}</option>
                      {['list', 'grid'].map(option => {
                        return <option value={option} key={option}>
                          {I18n.t(`js.filters.viewMode.${option}`)}
                        </option>
                      })}
                    </select>

                    <select
                      className={`form-control minW-165px gray-label ${filters.sort_by ? 'selected-label' : ''}`}
                      name="sort_by"
                      id="sort_by"
                      value={filters.sort_by ? filters.sort_by : ''}
                      onChange={(e) => getPrepaidCardsByMatchingFilters('sort_by', e.target.value)}>
                      <option value="" disabled hidden>{I18n.t('js.indexSubmissionListsPage.sortBy')}</option>
                      {sorting_options.filter(option => option.value).map(option => {
                        return <option value={option.value} key={option.value}>{I18n.t(option.locale)}</option>
                      })}
                    </select>


                    {
                      filters.sort_by &&
                      <div className="d-flex justify-content-center align-items-center px-0 cursor-pointer ml-3"
                           onClick={(e) => getPrepaidCardsByMatchingFilters('sorting_direction', filters.sorting_direction === 'desc' ? 'asc' : 'desc')}>
                        <div className="d-flex justify-content-center align-items-center blue-label minW-38px">
                          <p className="my-0 mr-2">
                            { filters.sorting_direction === 'desc' ? '↓' : '↑' }
                          </p>
                          <p className="my-0">
                            { I18n.t(`js.filters.sort.${filters.sorting_direction}endingSuperCompact`) }
                          </p>
                        </div>
                      </div>
                    }
                  </div>
              }
            </div>
          </div>




          {/*  SEZIONE DEDICATA ALL'ELENCO DI TUTTE LE CARTE PREPAGATE' */}
          <div id="submission_lists_header_container">
            {
              (loading || changeViewMode) ?
                <div className="d-flex justify-content-center my-5">
                  <div className="d-flex align-items-center text-intense-blue text-weight-500">
                    <div className="spinner-border" role="status"/>
                    <b className="ml-2">{I18n.t('js.indexPrepaidCards.loading')}</b>
                  </div>
                </div>
              :
                prepaidCards.length > 0 ?
                  <BottomScrollListener onBottom={getPrepaidCards}>
                    {
                      viewMode === 'grid' ?
                        <PrepaidCardsGrid
                          prepaidCards={prepaidCards}
                          prepaidCardsAnimationDivider={prepaidCardsAnimationDivider}
                        />
                      :
                        <PrepaidCardsList
                          prepaidCards={prepaidCards}
                          prepaidCardsAnimationDivider={prepaidCardsAnimationDivider}
                          isSuperMiddleman={isSuperMiddleman}
                        />
                    }


                    {
                      !hasLoadedAllPrepaidCards && prepaidCards.length > 0 &&
                        <div className="d-flex justify-content-center mb-5  mt-0">
                          <div className="d-flex align-items-center text-intense-blue text-weight-500">
                            <div className="spinner-border" role="status"/>
                            <b className="ml-2">{I18n.t('js.indexPrepaidCards.loading')}</b>
                          </div>
                        </div>
                    }
                  </BottomScrollListener>
                  :
                  <div className="d-flex justify-content-center">
                    <div className="d-flex align-items-center text-muted ml-md-3 mr-md-3 mt-md-4 text-center text-space">
                      <b className="ml-2">{I18n.t('js.filters.noResultsFoundPrepaidCard')}</b>
                    </div>
                  </div>
            }
          </div>
        </div>
      </div>

      <ErrorModal
        showErrorModal={showErrorModal}
        setShowErrorModal={setShowErrorModal}
      />
    </React.Fragment>
  );
};

export default IndexPrepaidCards;